import React, { useEffect, useState } from 'react'
import {
    Tooltip,
    Box,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Dialog,
    DialogContent,
    Chip,
    Button,
    MenuItem,
} from '@mui/material'
import { Formik } from 'formik'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SupplierDialog from '../Components/SupplierDialog';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import CreateIcon from '@mui/icons-material/Create';
import { toast, useToastContainer } from 'react-toastify';
import SearchIcon from '@mui/icons-material/Search';
import ItemDialog from '../Components/ItemDialog';
import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelIcon from "@mui/icons-material/Cancel";
import logo from '../Assests/paw.png'



function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function ItemManagement() {
    const [pageTitle, setPageTitle] = useState('Mange Items');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [itemList, setItemList] = useState([]);
    const [itemSearch, setItemSearch] = useState("");
    const [listImageView, setListImageView] = useState();
    const [imageDialog, setImageDialog] = useState(false);
    const [updateID, setUpdateID] = useState(0);
    const [status, setStatus] = useState(1);
    const [itemGridList, setItemGridList] = useState([]);

    useEffect(() => {
        GetAllItemDetailForGrid();
    }, [])

    useEffect(() => {
        if (updateID === 0 && dialogOpen === false) {
            GetAllItemDetailForGrid();
        }
    }, [updateID])

    useEffect(() => {
        GetAllItemDetailForGrid();
    }, [status])

    useEffect(() => {
        if (dialogOpen === false) {
            GetAllItemDetailForGrid();
        }
    }, [dialogOpen])

    function handleClick() {
        setDialogOpen(true);
    }

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - itemGridList.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    function GetAllItemDetailForGrid() {
        axios.get('https://serveremilia.mylksystems.com/Item/getItemDetails').then((res) => {
            if (res.data.length > 0) {
                setItemList(res.data);
                const FilterData = res.data.filter(itemStatus => itemStatus.IsActive === status);
                setItemGridList(FilterData);
            } else {
                setItemList([]);
                toast.error("No records to display!");
            }
        })
    }

    function ViewImage(itemImage) {
        setListImageView(itemImage);
        setImageDialog(true)
    }

    function UpdateRowData(rowID) {
        setUpdateID(rowID);
        setDialogOpen(true);
    }

    function removeImage() {
        setImageDialog(false)
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={11} xs={11}>
                    {titleName}
                </Grid>
                <Grid item md={1} xs={1}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center' >

                        <Button variant="contained" endIcon={<AddCircleOutlineIcon />} onClick={() => handleClick()} sx={{ width: '100%' }}>
                            Add
                        </Button>

                    </Box>
                </Grid>
            </Grid>
        )
    }

    return (
        <>
            <Container maxWidth={false} sx={{ paddingTop: '15vh' }}>
                <Formik
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form >
                            <Card sx={{ padding: '15px' }}>
                                <CardHeader
                                    title={cardTitle(pageTitle)}
                                />
                                <Divider />
                                <br />
                                <TableContainer>
                                    <Grid container spacing={2}>
                                        <Grid item md={6} sx={6}>
                                            <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                                <TextField
                                                    sx={{ width: { md: '50%', xs: '60%' } }}
                                                    variant="outlined"
                                                    value={itemSearch}
                                                    onChange={(e) => { setItemSearch(e.target.value) }}
                                                    size='small'
                                                />
                                                <SearchIcon sx={{ color: 'action.active', mr: 1, my: 1 }} style={{marginLeft : 10}} />
                                            </Box>
                                        </Grid>
                                        <Grid item md={6} sx={6}>
                                            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    name='status'
                                                    value={status}
                                                    id='status'
                                                    onChange={(e) => { setStatus(e.target.value) }}
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ width: { md: '30%', xs: '60%' } }}
                                                >
                                                    <MenuItem key={1} value={1}>Active</MenuItem>
                                                    <MenuItem key={0} value={0}>Inactive</MenuItem>
                                                </TextField>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <br />
                                    <Table sx={{ minWidth: 500 }} size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>#</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>Item Name</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>Item Category</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>Cost Price (Rs.)</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>Selling Price (Rs.)</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>Item Image</TableCell>
                                                {/* <TableCell align='center' sx={{ fontWeight: 'bold' }}>Item Status</TableCell> */}
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? itemGridList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : itemGridList
                                            ).filter((element) => {
                                                if (itemSearch === "") {
                                                    return element;
                                                } else if ((element.ItemName.toLowerCase().trim()).includes(itemSearch.toLowerCase().trim())) {
                                                    return element;
                                                } else if ((element.CategoryName.toLowerCase().trim()).includes(itemSearch.toLowerCase().trim())) {
                                                    return element;
                                                }
                                            }).map((row, index) => (
                                                <TableRow key={row._id}>
                                                    <TableCell align='center'>{index + 1}</TableCell>
                                                    <TableCell align='center'>{row.ItemName}</TableCell>
                                                    <TableCell align='center'>{row.CategoryName}</TableCell>
                                                    <TableCell align='center'>{row.costPrice}</TableCell>
                                                    <TableCell align='center'>{row.sellingPrice}</TableCell>
                                                    <TableCell align='center'>
                                                        <IconButton onClick={() => ViewImage(row.ItemImage)}>
                                                            <VisibilityIcon sx={{ color: 'black' }} />
                                                        </IconButton>
                                                    </TableCell>
                                                    {/* <TableCell align='center'>{row.IsActive == 1 ? <Chip label="Active" color="primary" /> : <Chip label="Inactive" color="error" />}</TableCell> */}
                                                    <TableCell align='center'>
                                                        <IconButton>
                                                            <CreateIcon sx={{ color: 'black' }} onClick={() => UpdateRowData(row.ItemID)} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={8} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 25, 35, { label: 'All', value: -1 }]}
                                                    colSpan={8}
                                                    count={itemGridList.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    slotProps={{
                                                        select: {
                                                            inputProps: {
                                                                'aria-label': 'rows per page',
                                                            },
                                                            native: true,
                                                        },
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>

                                {/* image preview dialog */}
                                <Dialog open={imageDialog}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            paddingTop: "1vh",
                                            paddingRight: "1vw",
                                        }}
                                    >
                                        <IconButton>
                                            <CancelIcon
                                                sx={{ color: "red", }}
                                                onClick={removeImage}
                                            />
                                        </IconButton>
                                    </Box>
                                    <DialogContent>
                                        <Card
                                            style={{
                                                height: 400,
                                                width: 300,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            {listImageView ?
                                                <img
                                                    src={`https://serveremilia.mylksystems.com/Assets/Items/${listImageView}`}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'contain'
                                                    }}
                                                    alt='imag'
                                                />
                                                :
                                                <img
                                                    src={logo}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'contain'
                                                    }}
                                                    alt='imag'
                                                />
                                            }
                                        </Card>
                                    </DialogContent>
                                </Dialog>

                            </Card>
                        </form>
                    )}

                </Formik>
            </Container>

            {/* item manegemnet dialog box */}
            <ItemDialog
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                updateID={updateID}
                setUpdateID={setUpdateID}
            />
        </>
    )
}

export default ItemManagement